import React, {Component, useState, useEffect} from 'react';
import {connect} from 'react-redux';

const UserInquiryListContainer = (props) => {

  const [isLoaded, setIsLoaded] = useState(false)
  const [state, setState] = useState({})

  useEffect(() => {

  })

  return (
    <div>
      UserInquiryListContainer
    </div>
  )
}

const enhance = connect(
  state => ({
    ...state
  }),
  {}
);

export default enhance(UserInquiryListContainer);
